module.exports = __webpack_public_path__ + "img/image12.f06e9303.webp";